// 用户模块
const state = {
  isLogin: false,
  token: '',
  userInfo: null
}

const mutations = {
  SET_LOGIN_STATE(state, isLogin) {
    state.isLogin = isLogin
  },
  SET_TOKEN(state, token) {
    state.token = token
  },
  SET_USER_INFO(state, userInfo) {
    state.userInfo = userInfo
  }
}

const actions = {
  // 初始化用户认证状态
  initAuth({ commit }) {
    return new Promise((resolve) => {
      const token = uni.getStorageSync('token')
      if (token) {
        commit('SET_TOKEN', token)
        commit('SET_LOGIN_STATE', true)
        resolve(true)
      } else {
        commit('SET_TOKEN', '')
        commit('SET_LOGIN_STATE', false)
        resolve(false)
      }
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
} 